"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var local_storage_1 = require("../utils/local-storage");
exports.VOD_USE_TEST_SERVER_KEY = 'VOD_USE_TEST_SERVER';
exports.VOD_API_URL_LS_KEY = 'VOD_API_URL';
/*
  __vodEnv.clear() - go back to no overrides
  __vodEnv.setTest() - test server with v1 backend
  __vodEnv.setTest().setV2() - test with v2 backend
  __vodEnv.setV2() - prod with v2 backend
 */
var EnvConfig = /** @class */ (function () {
    function EnvConfig() {
    }
    EnvConfig.prototype.setTest = function () {
        local_storage_1.browserLocalStorage.setItem(exports.VOD_USE_TEST_SERVER_KEY, true);
        local_storage_1.browserLocalStorage.setItem(exports.VOD_API_URL_LS_KEY, '//vod-test.wix.com');
        return this;
    };
    EnvConfig.prototype.setV2 = function () {
        local_storage_1.browserLocalStorage.setItem(exports.VOD_API_URL_LS_KEY, "//" + (this.isTest() ? 'vod-test.wix.com' : 'vod.wix.com') + "/api/v2");
        return this;
    };
    EnvConfig.prototype.clear = function () {
        local_storage_1.browserLocalStorage.removeItem(exports.VOD_USE_TEST_SERVER_KEY);
        local_storage_1.browserLocalStorage.removeItem(exports.VOD_API_URL_LS_KEY);
        return this;
    };
    EnvConfig.prototype.isProduction = function () {
        if (typeof window === 'undefined') {
            return false;
        }
        return /useProdServer/.test(window.location.href);
    };
    EnvConfig.prototype.isTest = function () {
        if (typeof window === 'undefined') {
            return false;
        }
        return Boolean(/useTestServer/.test(window.location.href) ||
            local_storage_1.browserLocalStorage.getItem(exports.VOD_USE_TEST_SERVER_KEY));
    };
    return EnvConfig;
}());
exports.EnvConfig = EnvConfig;
//# sourceMappingURL=env-config.js.map